import * as React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';

import { flagPost, unflagPost } from 'bundles/discussions/actions/DropdownActions';
import DiscussionsModal from 'bundles/discussions/components/DiscussionsModal';

import _t from 'i18n!nls/discussions';

class FlaggingModal extends React.Component {
  static propTypes = {
    handleClose: PropTypes.func.isRequired,
    post: PropTypes.object.isRequired,
    onFlaggingSuccess: PropTypes.func,
  };

  static contextTypes = {
    executeAction: PropTypes.func.isRequired,
  };

  declare context: LegacyContextType<typeof FlaggingModal.contextTypes>;

  okayButton = React.createRef<HTMLButtonElement>();

  state = {
    error: false,
    saving: false,
    success: false,
  };

  handleSubmitError = () => {
    this.setState({ saving: false, error: true });
    this.okayButton?.current?.focus();
  };

  getBodyText() {
    if (this.isActive()) {
      return _t('Are you sure you want to resolve the reported post?');
    } else {
      return _t('Are you sure you want to report this post?');
    }
  }

  getNotificationText() {
    if (this.state.success) {
      return _t('Thank you. We will review it and take appropriate action.');
    }

    if (this.state.error) {
      return _t('Sorry, an error occurred. Please try again later.');
    }

    return null;
  }

  flagAction = () => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'post' does not exist on type 'Readonly<{... Remove this comment to see the full error message
    const { post } = this.props;
    this.setState({ saving: true, success: false, error: false });
    if (this.isActive()) {
      this.context.executeAction(unflagPost, {
        post,
        handleSuccess: () => {
          // @ts-expect-error ts-migrate(2339) FIXME: Property 'handleClose' does not exist on type 'Rea... Remove this comment to see the full error message
          this.props.handleClose();
          // @ts-expect-error ts-migrate(2339) FIXME: Property 'onFlaggingSuccess' does not exist on type 'Rea... Remove this comment to see the full error message
          this.props.onFlaggingSuccess?.(true);
        },
        handleFailure: this.handleSubmitError,
      });
    } else {
      this.context.executeAction(flagPost, {
        post,
        handleSuccess: () => {
          this.setState({ success: true, saving: false });

          this.okayButton?.current?.focus();

          // @ts-expect-error ts-migrate(2339) FIXME: Property 'onFlaggingSuccess' does not exist on type 'Rea... Remove this comment to see the full error message
          this.props.onFlaggingSuccess?.(false);
        },
        handleFailure: this.handleSubmitError,
      });
    }
  };

  isActive = () => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'post' does not exist on type 'Readonly<{... Remove this comment to see the full error message
    return this.props.post.flagDetails && this.props.post.flagDetails.isActive;
  };

  renderButtonContainer() {
    if (this.state.error || this.state.success) {
      return (
        <div className="horizontal-box align-items-absolute-center button-container">
          {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'handleClose' does not exist on type 'Rea... Remove this comment to see the full error message */}
          <button className="primary" type="button" onClick={this.props.handleClose} ref={this.okayButton}>
            {_t('Okay')}
          </button>
        </div>
      );
    }

    return (
      <div className="horizontal-box align-items-right button-container">
        {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'handleClose' does not exist on type 'Rea... Remove this comment to see the full error message */}
        <button className="passive never-mind" type="button" onClick={this.props.handleClose}>
          {_t('Never mind')}
        </button>
        <button
          className="secondary"
          type="button"
          onClick={this.flagAction}
          disabled={this.state.error || this.state.saving}
        >
          {this.isActive() ? _t('Resolve') : _t('Report')}
        </button>
      </div>
    );
  }

  render() {
    const modalTextClasses = classNames('modal-text', {
      'body-1-text': !this.state.success,
      'body-2-text': this.state.success,
      success: this.state.success,
    });

    const isNotification = this.state.error || this.state.success;
    const modalTitle = this.isActive() && !isNotification ? _t('Resolve report') : _t('Report as inappropriate');

    return (
      <DiscussionsModal
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'handleClose' does not exist on type 'Rea... Remove this comment to see the full error message
        handleClose={this.props.handleClose}
        allowClose={!isNotification}
        modalName={modalTitle}
      >
        {this.state.success || <h3 className="c-modal-title headline-3-text">{modalTitle}</h3>}
        <p className={modalTextClasses}>
          {!isNotification && this.getBodyText()}
          <span aria-live="assertive">{isNotification && this.getNotificationText()}</span>
        </p>
        {this.renderButtonContainer()}
      </DiscussionsModal>
    );
  }
}

export default FlaggingModal;
